import React from 'react';
import styles from './css/Error.module.css';
import { Row, Col, Layout, Menu as AntdMenu } from 'antd';
import { Footer, FormMessage } from "./CorePageContents";

const { Content } = Layout;

export const SystemMaintenance = () => {

  // 環境によってサービス利用時間の表記を変える
  const getServiceAvailableTime = () => {
    if (window.location.hostname.startsWith('t2') || window.location.hostname.startsWith('s2')) {
      return "月 ～ 金　　午前9:00 ～ 午後10:00（22:00）";
    } else {
      return "月 ～ 土　　午前7:00 ～ 午後10:00（22:00）";
    }
  }

  return (
    <Layout>
      <Row className={styles.HeaderArea}>
        <Col span={6} className={styles.HeaderlogoArea}>
          <img
            className={styles.LogoStyle}
            src={process.env.PUBLIC_URL + '/header_logo_green.png'}
            alt="スキルマップサイト" />
        </Col>
      </Row>


      <AntdMenu className={styles.HeaderMenu}>
      </AntdMenu>

      <Content>
        <div className={styles.mainMessage}>ただいまメンテナンス中です</div>
        <br />
        <br />
        <div className={styles.subMessage}>
          平素は「スキルマップサイト」をご利用いただき、誠にありがとうございます。
          <br />
          <br />
          誠に申し訳ございませんが、ただ今の時間帯はシステムのサービス提供時間外となっております。<br />
          大変お手数ですが、以下のご利用可能時間内に再度アクセスしていただきますようお願い申し上げます。
        </div>
        <br />
        <div className={styles.mainMessage}>【サービスご利用可能時間】</div>
        <div className={styles.mainMessage}>{getServiceAvailableTime()}</div>
        <br />
        <br />
        <br />
        <FormMessage />
      </Content>
      <Footer />
    </Layout >
  );
}